import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { forkJoin, Observable, of } from 'rxjs';
import { map, mergeMap, catchError, concatMap, takeLast, tap, exhaustMap, withLatestFrom } from 'rxjs/operators';
import { Pagination, PermissionAssigneeTargetLinkContainerModel, PermissionService, TenantPermissionAssigneeTargetService, TenantRoleContainerModel, TenantRoleService, TenantTeamRoleContainerModel, TenantTeamRoleService, TenantUserRoleContainerModel, TenantUserRoleService } from 'blg-akaun-ts-lib';
import { ToastrService } from 'ngx-toastr';
import { AppConfig } from '../../../../visa';
import { BranchSettingsActions } from '../actions';
import { BranchSettingsStates } from '../states';
import { BranchSettingsSelectors } from '../selectors';
import {
  BranchService, AppletSettingFilterItemCategoryLinkService, AppletSettingFilterItemCategoryLinkContainerModel, BranchSettlementMethodService,
  FinancialItemService, BranchPricingSchemeHdrLinkService, BranchDefaultPrintableFormatHdrService, BranchDefaultPrintableFormatHdrContainerModel,
  PrintableFormatImageService, PrintableFormatImageContainerModel, PrintableFormatImageLinkService, PrintableFormatImageLinkContainerModel,
  EmployeeBranchLinkingService, EmployeeBranchLinkContainerModel
} from 'blg-akaun-ts-lib';
import { BranchSettingsFacade } from "../../facades/branch-settings.facade";
import { Store } from "@ngrx/store";

@Injectable()
export class BranchSettingsEffects {

    private readonly apiVisa = AppConfig.apiVisa;
    private readonly masterVisa = AppConfig.masterVisa;

    updateBranchDetails$ = createEffect(() => this.actions$.pipe(
      ofType(BranchSettingsActions.updateBranchDetails),
      concatMap(action => this.branchService.getByGuid(action.guid.toString(), this.apiVisa)
        .pipe(
          map(a => a.data),
          map(b => {
            if(action.form.value.salesAgent){
              b.bl_fi_mst_branch.default_sales_entity_hdr_guid = action.form.value.salesAgent;
            }else{
              b.bl_fi_mst_branch.default_sales_entity_hdr_guid = null;
            }
            if(action.form.value.rounding_five_cent){
              b.bl_fi_mst_branch.rounding_five_cent = action.form.value.rounding_five_cent;
              b.bl_fi_mst_branch.rounding_item_guid = action.form.value.rounding_item_guid;
            }else{
              b.bl_fi_mst_branch.rounding_five_cent = false;
              b.bl_fi_mst_branch.rounding_item_guid = null;
            }
            if(action.form.value.group_discount_item_guid){
              b.bl_fi_mst_branch.group_discount_item_guid = action.form.value.group_discount_item_guid;
            }else{
              b.bl_fi_mst_branch.group_discount_item_guid = null;
            }

            if(action.form.value.default_settlement_cash){
              b.bl_fi_mst_branch.default_settlement_method_json = <any> {...b.bl_fi_mst_branch.default_settlement_method_json,
                "default_settlement_cash":action.form.value.default_settlement_cash
              }
            } else {
              if (b.bl_fi_mst_branch.default_settlement_method_json?.hasOwnProperty("default_settlement_cash")) {
                delete b.bl_fi_mst_branch.default_settlement_method_json["default_settlement_cash"];
              }
            }
            if(action.form.value.default_settlement_credit_card){
              b.bl_fi_mst_branch.default_settlement_method_json = <any> {...b.bl_fi_mst_branch.default_settlement_method_json,
                "default_settlement_credit_card":action.form.value.default_settlement_credit_card
              }
            } else {
              if (b.bl_fi_mst_branch.default_settlement_method_json?.hasOwnProperty("default_settlement_credit_card")) {
                delete b.bl_fi_mst_branch.default_settlement_method_json["default_settlement_credit_card"];
              }
            }
            if(action.form.value.default_settlement_debit_card){
              b.bl_fi_mst_branch.default_settlement_method_json = <any> {...b.bl_fi_mst_branch.default_settlement_method_json,
                "default_settlement_debit_card":action.form.value.default_settlement_debit_card
              }
            } else {
              if (b.bl_fi_mst_branch.default_settlement_method_json?.hasOwnProperty("default_settlement_debit_card")) {
                delete b.bl_fi_mst_branch.default_settlement_method_json["default_settlement_debit_card"];
              }
            }
            if(action.form.value.default_settlement_voucher){
              b.bl_fi_mst_branch.default_settlement_method_json = <any> {...b.bl_fi_mst_branch.default_settlement_method_json,
                "default_settlement_voucher":action.form.value.default_settlement_voucher
              }
            } else {
              if (b.bl_fi_mst_branch.default_settlement_method_json?.hasOwnProperty("default_settlement_voucher")) {
                delete b.bl_fi_mst_branch.default_settlement_method_json["default_settlement_voucher"];
              }
            }
            if(action.form.value.default_settlement_bank_transfer){
              b.bl_fi_mst_branch.default_settlement_method_json = <any> {...b.bl_fi_mst_branch.default_settlement_method_json,
                "default_settlement_bank_transfer":action.form.value.default_settlement_bank_transfer
              }
            } else {
              if (b.bl_fi_mst_branch.default_settlement_method_json?.hasOwnProperty("default_settlement_bank_transfer")) {
                delete b.bl_fi_mst_branch.default_settlement_method_json["default_settlement_bank_transfer"];
              }
            }
            if(action.form.value.default_settlement_cheque){
              b.bl_fi_mst_branch.default_settlement_method_json = <any> {...b.bl_fi_mst_branch.default_settlement_method_json,
                "default_settlement_cheque":action.form.value.default_settlement_cheque
              }
            } else {
              if (b.bl_fi_mst_branch.default_settlement_method_json?.hasOwnProperty("default_settlement_cheque")) {
                delete b.bl_fi_mst_branch.default_settlement_method_json["default_settlement_cheque"];
              }
            }
            if(action.form.value.default_settlement_others){
              b.bl_fi_mst_branch.default_settlement_method_json = <any> {...b.bl_fi_mst_branch.default_settlement_method_json,
                "default_settlement_others":action.form.value.default_settlement_others
              }
            } else {
              if (b.bl_fi_mst_branch.default_settlement_method_json?.hasOwnProperty("default_settlement_others")) {
                delete b.bl_fi_mst_branch.default_settlement_method_json["default_settlement_others"];
              }
            }
            if(action.form.value.default_settlement_ewallet){
              b.bl_fi_mst_branch.default_settlement_method_json = <any> {...b.bl_fi_mst_branch.default_settlement_method_json,
                "default_settlement_ewallet":action.form.value.default_settlement_ewallet
              }
            } else {
              if (b.bl_fi_mst_branch.default_settlement_method_json?.hasOwnProperty("default_settlement_ewallet")) {
                delete b.bl_fi_mst_branch.default_settlement_method_json["default_settlement_ewallet"];
              }
            }
            if(action.form.value.default_settlement_membership_point_currency){
              b.bl_fi_mst_branch.default_settlement_method_json = <any> {...b.bl_fi_mst_branch.default_settlement_method_json,
                "default_settlement_membership_point_currency":action.form.value.default_settlement_membership_point_currency
              }
            } else {
              if (b.bl_fi_mst_branch.default_settlement_method_json?.hasOwnProperty("default_settlement_membership_point_currency")) {
                delete b.bl_fi_mst_branch.default_settlement_method_json["default_settlement_membership_point_currency"];
              }
            }
            return b;
          }),
          mergeMap(res => this.branchService.put(res, this.apiVisa)
            .pipe(
              map((res: any) => {
                console.log('after update',res)
                this.toastr.success(
                  'Branch details has been updated successfully',
                  'Success',
                  {
                    tapToDismiss: true,
                    progressBar: true,
                    timeOut: 3000
                  }
                );
                this.viewColFacade.resetIndex(0);
                return BranchSettingsActions.updateBranchDetailsSuccess();
              }),
              catchError((err) => {
                this.toastr.error(
                  err.message,
                  'Error',
                  {
                    tapToDismiss: true,
                    progressBar: true,
                    timeOut: 3000
                  }
                );
                return of(BranchSettingsActions.updateBranchDetailsFailed({ error: err.messsage }));
              })
            ))

        ))
    ));

    saveSettingItemFilter$ = createEffect(() =>
      this.actions$.pipe(
        ofType(BranchSettingsActions.saveSettingItemFilter),
        withLatestFrom(this.store.select(BranchSettingsSelectors.selectItemCategoryFilter)),
        mergeMap(([action, settingItem]) => {
          const apiCalls = [];

          const processItemCategory = (lineTable, guids, exclude) => {
            const matchingSetting = settingItem.find(s => {
              const settingLevelValue = (s.bl_applet_setting_filter_fi_item_category_link as any)?.level_value;
              const settingGuidBranch = (s.bl_applet_setting_filter_fi_item_category_link as any)?.guid_branch;
              return settingLevelValue == lineTable && settingGuidBranch == action.branch;
            });

            let itemFilter = new AppletSettingFilterItemCategoryLinkContainerModel();
            itemFilter.bl_applet_setting_filter_fi_item_category_link.applet_guid = <any>sessionStorage.getItem('appletGuid');
            (itemFilter as any).bl_applet_setting_filter_fi_item_category_link.level_value = lineTable;
            (itemFilter as any).bl_applet_setting_filter_fi_item_category_link.guid_branch = action.branch;
            itemFilter.bl_applet_setting_filter_fi_item_category_link.line_table = lineTable;

            if (matchingSetting) {
              itemFilter = matchingSetting;
              const currentFilter = itemFilter.bl_applet_setting_filter_fi_item_category_link;

              if (exclude) {
                // Update exclude_category_json with guids
                currentFilter.exclude_category_json = guids ? <any> { guids } : {};
              } else {
                // Reset exclude_category_json if checkbox is unchecked
                currentFilter.exclude_category_json = {};
              }

              // Update category_json when not excluding
              if (!exclude) {
                currentFilter.category_json = guids ?<any>  { guids } : {};
              }

              apiCalls.push(this.itemFilterSettingService.put(itemFilter, this.apiVisa));
            } else {
              // New setting logic
              const categoryField = exclude ? 'exclude_category_json' : 'category_json';
              (itemFilter as any).bl_applet_setting_filter_fi_item_category_link[categoryField] = guids ? { guids } : {};
              if (guids || exclude) {
                apiCalls.push(this.itemFilterSettingService.postOne(itemFilter, this.apiVisa));
              }
            }
          };

          for (let i = 0; i <= 10; i++) {
            const categoryValue = action.form.value[`ITEM_CATEGORY_${i}`];
            const excludeChecked = action.form.value[`ITEM_CATEGORY_CHECKBOX_${i}`];
            processItemCategory(i.toString(), categoryValue, excludeChecked);
          }

          return forkJoin(apiCalls).pipe(
            tap(() => {
              this.toastr.success(
                'Item Category filters have been updated successfully',
                'Success',
                {
                  tapToDismiss: true,
                  progressBar: true,
                  timeOut: 3000
                }
              );
              this.viewColFacade.resetIndex(0);
              // this.store.dispatch(BranchSettingsActions.loadSettingItemFilter());
            }),
            map(() => BranchSettingsActions.saveSettingItemFilterSuccess()),
            catchError(err =>
              of(BranchSettingsActions.saveSettingItemFilterFailed({ error: err.message }))
            )
          );
        })
      )
    );


    selectSettingItemFilter$ = createEffect(() => this.actions$.pipe(
      ofType(BranchSettingsActions.selectSettingItemFilter),
      mergeMap((action) => {
        const paging = new Pagination();
        paging.conditionalCriteria.push({ columnName: 'applet_guid', operator: '=', value: sessionStorage.getItem('appletGuid') });
        paging.conditionalCriteria.push({ columnName: 'guid_branch', operator: '=', value: action.branch });

        return this.itemFilterSettingService.getByCriteria(paging, this.apiVisa).pipe(
          map(res => {
            return BranchSettingsActions.selectSettingItemFilterSuccess({ setting: res.data });
          }),
          catchError(err => {
            return of(BranchSettingsActions.selectSettingItemFilterFailed({ error: err.message }));
          })
        )
      })
    ));

    selectBranchSettlementMethodListInit$ = createEffect(() => this.actions$.pipe(
      ofType(BranchSettingsActions.selectBranchSettlementMethodListInit),
      mergeMap((action) => {
        const paging = new Pagination();
        paging.conditionalCriteria.push({ columnName: 'branch_guid', operator: '=', value: action.branchGuid.toString() });

        return this.branchSettlementMethodService.getByCriteria(paging, this.apiVisa).pipe(
          mergeMap(res => {
            return this.processList(res.data).pipe(
              map(processedList => {
                return BranchSettingsActions.selectBranchSettlementMethodListSucess({ container: processedList });
              }),
              catchError(err => {
                return of(BranchSettingsActions.selectBranchSettlementMethodListFailure({ error: err.message }));
              })
            );
          }),
          catchError(err => {
            return of(BranchSettingsActions.selectBranchSettlementMethodListFailure({ error: err.message }));
          })
        )
      })
    ));

    processList(list: any[]) {
      const observables = list.map((item) =>
        this.fiItemService.getByGuid(item.bl_fi_mst_branch_settlement_method.fi_item_hdr_guid.toString(), AppConfig.apiVisa).pipe(
          map(res => ({
            guid: res.data.bl_fi_mst_item_hdr.guid,
            code: res.data.bl_fi_mst_item_hdr.code,
            name: res.data.bl_fi_mst_item_hdr.name,
            settlementType: (() => {
              const ext = res.data.bl_fi_mst_item_exts.find(ext => ext.param_code === 'SETTLEMENT_TYPE' && ext.value_string !== null);
              return ext ? ext.value_string : "";
            })(),
          }))
        )
      );

      return forkJoin(observables);
    }

    createBranchPricingSchemeInit$ = createEffect(() => this.actions$.pipe(
      ofType(BranchSettingsActions.createBranchPricingSchemeInit),
      exhaustMap((a) => this.branchPricingService.postOne(a.container, this.apiVisa).pipe(
        map(b => {
          return BranchSettingsActions.createBranchPricingSchemeInitSucccess({ pricingScheme: b.data[0]});
        }),
        catchError(err => of(BranchSettingsActions.createBranchPricingSchemeFailure({ error: err.message })))
      )),
    ));

    deleteBranchPricingSchemeInit$ = createEffect(() => this.actions$.pipe(
      ofType(BranchSettingsActions.deleteBranchPricingSchemeInit),
      mergeMap(action => this.branchPricingService.delete(action.guid, this.apiVisa)
      .pipe(
          map(() => {
              this.displayToasterSuccess('Branch pricing scheme deleted successfully')
              return BranchSettingsActions.deleteBranchPricingSchemeInitSucccess();
          }),
          catchError((err) => {
              this.displayToasterError(err.message);
              return of(BranchSettingsActions.deleteBranchPricingSchemeFailure({error: err.message}));
          })
      ))
    ));

    editBranchPricingSchemeInit$ = createEffect(() => this.actions$.pipe(
      ofType(BranchSettingsActions.editBranchPricingSchemeInit),
      concatMap(action => this.branchPricingService.getByGuid(action.container.bl_fi_mst_branch_pricing_scheme_hdr_link.guid, this.apiVisa)
        .pipe(
          map(a => a.data),
          map(b => {
            b.bl_fi_mst_branch_pricing_scheme_hdr_link.level_value = action.container.bl_fi_mst_branch_pricing_scheme_hdr_link.level_value;
            b.bl_fi_mst_branch_pricing_scheme_hdr_link.guid_pricing_scheme_hdr = action.container.bl_fi_mst_branch_pricing_scheme_hdr_link.guid_pricing_scheme_hdr;
            return b;
          }),
          mergeMap(action => this.branchPricingService.put(action, this.apiVisa)
            .pipe(
              map((device: any) => {
                this.toastr.success(
                  'Branch pricing scheme has been updated successfully',
                  'Success',
                  {
                    tapToDismiss: true,
                    progressBar: true,
                    timeOut: 3000
                  }
                );
                return BranchSettingsActions.editBranchPricingSchemeInitSucccess({ pricingScheme: device.data });
              }),
              catchError((err) => {
                this.toastr.error(
                  err.message,
                  'Error',
                  {
                    tapToDismiss: true,
                    progressBar: true,
                    timeOut: 3000
                  }
                );
                return of(BranchSettingsActions.editBranchPricingSchemeFailure({ error: err.messsage }));
              })
            ))

        ))
    ));

    addBranchPrintableFormat$ = createEffect(() =>
      this.actions$.pipe(
        ofType(BranchSettingsActions.addBranchPrintableFormat),
        concatMap(({ branchGuid, form }) => {
          // Set up the pagination with the conditional criteria
          const paging = new Pagination();
          paging.conditionalCriteria.push({ columnName: 'branch_guid', operator: '=', value: branchGuid.toString() });
          paging.conditionalCriteria.push({ columnName: 'server_doc_type', operator: '=', value: 'INTERNAL_SALES_CASHBILL' });
          paging.conditionalCriteria.push({ columnName: 'printable_format_hdr_guids', operator: '=', value: form.printableFormatHdr });


          return this.branchPrintableService.getByCriteria(paging, this.apiVisa).pipe(
            map(response => response.data),
            concatMap(data => {
              if (data.length > 0) {
                // Edit scenario: Update the existing record
                const existingContainer = data[0];
                existingContainer.bl_fi_mst_branch_default_printable_format_hdr.header = form.header;
                existingContainer.bl_fi_mst_branch_default_printable_format_hdr.footer = form.footer;
                existingContainer.bl_fi_mst_branch_default_printable_format_hdr.default_printable_format_guid = form.printableFormatHdr;
                existingContainer.bl_fi_mst_branch_default_printable_format_hdr.priority = form.priority;

                return this.branchPrintableService.put(existingContainer, this.apiVisa).pipe(
                  map(() => {
                    this.toastr.success(
                      'Branch printable format added successfully',
                      'Success',
                      {
                        tapToDismiss: true,
                        progressBar: true,
                        timeOut: 3000,
                      }
                    );
                    this.store.dispatch(BranchSettingsActions.selectDefaultPrintableFormatInit({branchGuid: branchGuid.toString(),serverDocType:"INTERNAL_SALES_CASHBILL"}))
                    this.viewColFacade.onPrev(1);
                    return BranchSettingsActions.addBranchPrintableFormatSuccess();
                  }),
                  catchError(err => {
                    this.toastr.error(
                      err.message,
                      'Error',
                      {
                        tapToDismiss: true,
                        progressBar: true,
                        timeOut: 3000,
                      }
                    );
                    return of(BranchSettingsActions.addBranchPrintableFormatFailed({ error: err.message }));
                  })
                );
              } else {
                // Add scenario: Create a new record
                const newContainer: BranchDefaultPrintableFormatHdrContainerModel = new BranchDefaultPrintableFormatHdrContainerModel()
                newContainer.bl_fi_mst_branch_default_printable_format_hdr.branch_guid = form.branchGuid;
                newContainer.bl_fi_mst_branch_default_printable_format_hdr.branch_code = form.branchCode;
                newContainer.bl_fi_mst_branch_default_printable_format_hdr.branch_name = form.branchName;
                newContainer.bl_fi_mst_branch_default_printable_format_hdr.server_doc_type = 'INTERNAL_SALES_CASHBILL';
                newContainer.bl_fi_mst_branch_default_printable_format_hdr.header = form.header;
                newContainer.bl_fi_mst_branch_default_printable_format_hdr.footer = form.footer;
                newContainer.bl_fi_mst_branch_default_printable_format_hdr.default_printable_format_guid = form.printableFormatHdr;
                newContainer.bl_fi_mst_branch_default_printable_format_hdr.priority = form.priority;
                newContainer.bl_fi_mst_branch_default_printable_format_hdr.branch_guid = branchGuid;

                return this.branchPrintableService.postOne(newContainer, this.apiVisa).pipe(
                  map(() => {
                    this.toastr.success(
                      'Branch printable format created successfully',
                      'Success',
                      {
                        tapToDismiss: true,
                        progressBar: true,
                        timeOut: 3000,
                      }
                    );
                    this.viewColFacade.onPrev(1);
                    return BranchSettingsActions.addBranchPrintableFormatSuccess();
                  }),
                  catchError(err => {
                    this.toastr.error(
                      err.message,
                      'Error',
                      {
                        tapToDismiss: true,
                        progressBar: true,
                        timeOut: 3000,
                      }
                    );
                    return of(BranchSettingsActions.addBranchPrintableFormatFailed({ error: err.message }));
                  })
                );
              }
            })
          );
        })
      )
    );

    editBranchPrintableFormat$ = createEffect(() => this.actions$.pipe(
      ofType(BranchSettingsActions.editBranchPrintableFormat),
      concatMap(action => this.branchPrintableService.getByGuid(action.guid, this.apiVisa)
        .pipe(
          map(a => a.data),
          map(b => {
            b.bl_fi_mst_branch_default_printable_format_hdr.priority = action.form.priority;
            b.bl_fi_mst_branch_default_printable_format_hdr.header = action.form.header;
            b.bl_fi_mst_branch_default_printable_format_hdr.footer = action.form.footer;
            b.bl_fi_mst_branch_default_printable_format_hdr.default_printable_format_guid = action.form.printableFormatHdr;

            return b;
          }),
          mergeMap(c => this.branchPrintableService.put(c, this.apiVisa)
            .pipe(
              map((a: any) => {
                this.toastr.success(
                  'Branch printable has been updated successfully',
                  'Success',
                  {
                    tapToDismiss: true,
                    progressBar: true,
                    timeOut: 3000
                  }
                );
                this.viewColFacade.onPrev(1);
                this.store.dispatch(BranchSettingsActions.selectDefaultPrintableFormatInit({branchGuid: action.branchGuid.toString(),serverDocType:"INTERNAL_SALES_CASHBILL"}))
                return BranchSettingsActions.editBranchPrintableFormatSuccess();
              }),
              catchError((err) => {
                this.toastr.error(
                  err.message,
                  'Error',
                  {
                    tapToDismiss: true,
                    progressBar: true,
                    timeOut: 3000
                  }
                );
                return of(BranchSettingsActions.editBranchPrintableFormatFailed({ error: err.messsage }));
              })
            ))

        ))
    ));

    deleteBranchPrintableFormatInit$ = createEffect(() => this.actions$.pipe(
      ofType(BranchSettingsActions.deleteBranchPrintableFormatInit),
      mergeMap(action => this.branchPrintableService.delete(action.guid, this.apiVisa)
      .pipe(
          map(() => {
              this.displayToasterSuccess('Branch printable deleted successfully');
              this.viewColFacade.onPrev(1);
              return BranchSettingsActions.deleteBranchPrintableFormattSucccess();
          }),
          catchError((err) => {
              this.displayToasterError(err.message);
              return of(BranchSettingsActions.deleteBranchPrintableFormatFailure({error: err.message}));
          })
      ))
    ));

    addPrintableImageInit$ = createEffect(() => this.actions$.pipe(
      ofType(BranchSettingsActions.addPrintableImageInit),
      withLatestFrom(
        this.store.select(BranchSettingsSelectors.selectBranch),
      ),
      exhaustMap(([action, branch]) => {
        let formData: FormData = new FormData();
        let container = new PrintableFormatImageContainerModel();
        const file = action.data.attachment.file

        container.bl_prt_printable_format_image_hdr.image_code = action.data.imageCode;
        container.bl_prt_printable_format_image_hdr.image_name = action.data.imageName;
        container.bl_prt_printable_format_image_hdr.property_json = action.data.attachment.fileAttributes;
        container.bl_prt_printable_format_image_hdr.acl_config = action.data.attachment.fileAttributes;
        container.bl_prt_printable_format_image_hdr.branch_guid = branch.guid;

        const containerBlob = new Blob([JSON.stringify(container)], {
          type: 'application/json'
        });

        const fileDataBlob = new Blob([JSON.stringify(file)], {
          type: 'application/json'
        });

        formData.append("data", containerBlob);
        formData.append('files', file);
        formData.append("file-data", fileDataBlob);

        return this.printableFormatImageService.postWithAttachments(formData, this.apiVisa).pipe(
          map((a: any) => {
            this.displayToasterSuccess('Printable image added successfully');
            this.viewColFacade.onPrev(1);
            return BranchSettingsActions.addPrintableImageSuccess();
          }),
          catchError(err => {
            this.toastr.error(
              err.message,
              'Error',
              {
                tapToDismiss: true,
                progressBar: true,
                timeOut: 2000
              }
            );
            return of(BranchSettingsActions.addPrintableImageFailed({ error: err.message }));
          })
        )
      })
    ))

    editPrintableImageInit$ = createEffect(() => this.actions$.pipe(
      ofType(BranchSettingsActions.editPrintableImageInit),
      withLatestFrom(
        this.store.select(BranchSettingsSelectors.selectPrintableImage)
      ),
      exhaustMap(([action, draftData]) => {

        console.log('draftData',draftData)
        let formData: FormData = new FormData();

        const file = action.data.file

        const fileDataBlob = new Blob([JSON.stringify(file)], {
          type: 'application/json'
        });

        formData.append('file', file);
        formData.append("file-data", fileDataBlob);

        return this.printableFormatImageService.replaceFile(formData, draftData.guid.toString(), this.apiVisa).pipe(
          map((response) => {
            return { "response": response, "draftData": draftData, "data": action.data }
          }),
          catchError(err => {
            return of(err);
          })
        )
      }),
      exhaustMap((resolved) => {
        let container = resolved.response.data;
        container.bl_prt_printable_format_image_hdr.image_name = resolved.data.imageName;
        container.bl_prt_printable_format_image_hdr.acl_config = resolved.data.attachment.fileAttributes;
        return this.printableFormatImageService.put(container, this.apiVisa).pipe(
          map((a: any) => {
            this.displayToasterSuccess('Printable image updated successfully');
            this.viewColFacade.onPrev(1);
            return BranchSettingsActions.editPrintableImageSuccess();
          }),
          catchError(err => {
            this.toastr.error(
              err.message,
              'Error',
              {
                tapToDismiss: true,
                progressBar: true,
                timeOut: 2000
              }
            );
            return of(BranchSettingsActions.editPrintableImageFailed({ error: err.message }));
          })
        )
      })
    ))

    selectFile$ = createEffect(() => this.actions$.pipe(
      ofType(BranchSettingsActions.selectFile),
      exhaustMap(action =>
        this.printableFormatImageService.getByGuid(action.guid.toString(), this.apiVisa).pipe(
          exhaustMap((a: any) => {


            return this.printableFormatImageService.getFile(action.guid.toString(), this.apiVisa).pipe(
              map((b: any) => {
                console.log('file:', b);


                return BranchSettingsActions.selectFileSuccess({
                  file: b,
                });
              }),
              catchError(err => {
                console.error('Error fetching file:', err);
                return of(BranchSettingsActions.selectFileFailed({ error: err }));
              })
            );
          }),
          catchError(err => {
            console.error('Error fetching by GUID:', err);
            return of(BranchSettingsActions.selectFileFailed({ error: err }));
          })
        )
      )
    ));

    addPrintableImageLinkInit$ = createEffect(() => this.actions$.pipe(
      ofType(BranchSettingsActions.addPrintableImageLinkInit),
      concatMap(action => {
          const arr: PrintableFormatImageLinkContainerModel[] = [];
          action.images.forEach(guid => {
              const a = new PrintableFormatImageLinkContainerModel();
              a.bl_prt_printable_format_image_link.printable_format_guid = action.printableFormat;
              a.bl_prt_printable_format_image_link.image_guid = guid;
              arr.push(a)
          })

          return arr
      }),
      mergeMap(obj => this.printableFormatImageLinkService.post(obj, this.apiVisa)
      .pipe(
          takeLast(1),
          map(_ => {
              this.displayToasterSuccess('Printable image link added successfully');
              this.viewColFacade.onPrev(1);
              return BranchSettingsActions.addPrintableImageLinkSucess();
          }),
          catchError((err) => {
              this.displayToasterError(err.message);
              return of(BranchSettingsActions.addPrintableImageLinkFailure({error: err.message}))
          })
      ))
  ));

  deletePrintableImageLinkInit$ = createEffect(() => this.actions$.pipe(
    ofType(BranchSettingsActions.deletePrintableImageLinkInit),
    mergeMap(action => this.printableFormatImageLinkService.delete(action.guid, this.apiVisa)
    .pipe(
        map(() => {
            this.displayToasterSuccess('Printable image link deleted successfully');
            this.viewColFacade.onPrev(1);
            return BranchSettingsActions.deletePrintableImageLinkSucccess();
        }),
        catchError((err) => {
            this.displayToasterError(err.message);
            return of(BranchSettingsActions.deletePrintableImageLinkFailure({error: err.message}));
        })
    ))
  ));

  deletePrintableImageInit$ = createEffect(() => this.actions$.pipe(
    ofType(BranchSettingsActions.deletePrintableImageInit),
    mergeMap(action => this.printableFormatImageService.delete(action.guid, this.apiVisa)
    .pipe(
        map(() => {
            this.displayToasterSuccess('Printable image deleted successfully');
            this.viewColFacade.onPrev(1);
            return BranchSettingsActions.deletePrintableImageSucccess();
        }),
        catchError((err) => {
            this.displayToasterError(err.message);
            return of(BranchSettingsActions.deletePrintableImageFailure({error: err.message}));
        })
    ))
  ));

  selectDefaultPrintableFormatInit$ = createEffect(() => this.actions$.pipe(
    ofType(BranchSettingsActions.selectDefaultPrintableFormatInit),
    mergeMap((action) => {
      const paging = new Pagination();
      paging.limit = 1;
      paging.conditionalCriteria.push({ columnName: 'branch_guid', operator: '=', value: action.branchGuid.toString() });
      paging.conditionalCriteria.push({ columnName: 'server_doc_type', operator: '=', value: action.serverDocType.toString() });
      paging.sortCriteria = [
        { columnName: 'orderBy', value: 'priority' },
        { columnName: 'order', value: 'DESC' }
      ];
      return this.branchPrintableService.getByCriteria(paging, this.apiVisa).pipe(
        map(res => {
          const printable = res.data.length?res.data[0]:null
          return BranchSettingsActions.selectDefaultPrintableFormatSucess({ container: printable });
        }),
        catchError(err => {
          return of(BranchSettingsActions.selectDefaultPrintableFormatFailure({ error: err.message }));
        })
      )
    })
));

addEmployeeLinkInit$ = createEffect(() => this.actions$.pipe(
    ofType(BranchSettingsActions.addEmployeeLinkInit),
    concatMap(action => {
        const arr: EmployeeBranchLinkContainerModel[] = [];
        action.guids.forEach(guid => {
            const a = new EmployeeBranchLinkContainerModel();
            a.bl_fi_mst_branch_employee_link.guid_branch = action.branchGuid;
            a.bl_fi_mst_branch_employee_link.entity_hdr_guid = guid;
            arr.push(a)
        })

        return arr
    }),
    mergeMap(obj => this.employeeBranchLinkingService.post(obj, this.apiVisa)
    .pipe(
        takeLast(1),
        map(_ => {
            this.displayToasterSuccess('Employee branch link added successfully');
            this.viewColFacade.onPrev(1);
            return BranchSettingsActions.addEmployeeLinkSucess();
        }),
        catchError((err) => {
            this.displayToasterError(err.message);
            return of(BranchSettingsActions.addEmployeeLinkFailure({error: err.message}))
        })
    ))
  ));

  deleteEmployeeLinkInit$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BranchSettingsActions.deleteEmployeeLinkInit),
      withLatestFrom(this.store.select(BranchSettingsSelectors.selectEmployeeLink)),
      mergeMap(([action, employeeLink]) => {
        if (!employeeLink || employeeLink.length === 0) {
          this.displayToasterError('Error deleting employee link');
          return of(BranchSettingsActions.deleteEmployeeLinkFailure({ error: 'No employee link available to delete' }));
        }

        return this.employeeBranchLinkingService.delete(employeeLink[0].bl_fi_mst_branch_employee_link.guid.toString(), this.apiVisa).pipe(
          map(() => {
            this.displayToasterSuccess('Employee branch link deleted successfully');
            this.viewColFacade.onPrev(1);
            return BranchSettingsActions.deleteEmployeeLinkSucccess();
          }),
          catchError((err) => {
            this.displayToasterError(err.message);
            return of(BranchSettingsActions.deleteEmployeeLinkFailure({ error: err.message }));
          })
        );
      })
    )
  );


  selectEmployeeLink$ = createEffect(() => this.actions$.pipe(
    ofType(BranchSettingsActions.selectEmployeeLink),
    mergeMap((action) => {
      const paging = new Pagination();
      paging.conditionalCriteria.push({ columnName: 'entity_hdr_guid', operator: '=', value: action.employee.guid.toString()});
      paging.conditionalCriteria.push({ columnName: 'guid_branch', operator: '=', value: action.branch });

      return this.employeeBranchLinkingService.getByCriteria(paging, this.apiVisa).pipe(
        map(res => {
          return BranchSettingsActions.selectEmployeeLinkSuccess({ container: res.data });
        }),
        catchError(err => {
          return of(BranchSettingsActions.selectEmployeeLinkFailed({ error: err.message }));
        })
      )
    })
  ));


  displayToasterSuccess(message: string) {
    return this.toastr.success(
      message,
      'Success',
      {
        tapToDismiss: true,
        progressBar: true,
        timeOut: 1300
      }
    )
  }

  displayToasterError(message: string) {
    return this.toastr.error(
      message,
      'Error',
      {
        tapToDismiss: true,
        progressBar: true,
        timeOut: 1300
      }
    )
  }

    constructor(
      private actions$: Actions,
      private toastr: ToastrService,
      private branchService: BranchService,
      private viewColFacade: BranchSettingsFacade,
      private store: Store<BranchSettingsStates>,
      private itemFilterSettingService: AppletSettingFilterItemCategoryLinkService,
      private branchSettlementMethodService: BranchSettlementMethodService,
      private fiItemService: FinancialItemService,
      private branchPricingService: BranchPricingSchemeHdrLinkService,
      private branchPrintableService: BranchDefaultPrintableFormatHdrService,
      private printableFormatImageService: PrintableFormatImageService,
      private printableFormatImageLinkService: PrintableFormatImageLinkService,
      private employeeBranchLinkingService: EmployeeBranchLinkingService,
    ) {}
}
